import { Dialog } from 'primereact/dialog';
import React, { useEffect, useState } from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import { Button } from 'primereact/button';
import moment from 'moment';
import { get } from 'http';
import { useForm } from '../../../../shared/hooks/Form';
import { ToastService } from '../../../../AppToast';
import { InvoiceDiscountList } from '../../../../service/invoice/InvoiceDiscountList';
import { DialogSelectInvoiceDiscounted } from './DialogSelectInvoiceDiscounted';
import { useTranslation } from '../../../../shared/language';

type Props = {}

const DialogDiscountInvoiceAttachment = ({ display, setInvoices, setDisplay, selectedItems, reloadLazyData }) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState(null);
  const [discountInvoiceAttachment, setDiscountInvoiceAttachment] = useState<{ invoiceDiscountListItems?: any[] }>({ invoiceDiscountListItems: [] })
  const [displaySelectInvoiceDiscounted, setDisplaySelectInvoiceDiscounted] = useState(false)
  const [registerInvoice, setRegisterInvoice] = useState()
  const { render: renderForm, setValue, getValue, valid } = useForm({
    fields: [
      { field: 'invoiceListNumber', disabled: true, header: t('common.invoiceListNo'), className: 'md:col-4', labelClassName: 'md:col-4', inputClassName: 'md:col-8' },
      { field: 'sellerTaxCode', header: t('common.sellerTaxCode'), className: 'md:col-4', labelClassName: 'md:col-4', inputClassName: 'md:col-8', required: true },
      { field: 'buyerTaxCode', header: t('common.buyerTaxCode'), className: 'md:col-4', labelClassName: 'md:col-4', inputClassName: 'md:col-8', required: true, disabled: true },
      { field: 'invoiceListDate', header: t('common.invoiceListDate'), className: 'md:col-4', labelClassName: 'md:col-4', inputClassName: 'md:col-8', type: 'Calendar' },
      { field: 'sellerLegalName', header: t('common.sellerName'), className: 'md:col-4', labelClassName: 'md:col-4', inputClassName: 'md:col-8', required: true },
      { field: 'buyerLegalName', header: t('common.customerName'), className: 'md:col-4', labelClassName: 'md:col-4', inputClassName: 'md:col-8', required: true },
      { field: 'note', type: 'InputTextarea', header: t('common.note'), className: 'md:col-4', labelClassName: 'md:col-4', inputClassName: 'md:col-8' },
      { field: 'sellerAddress', type: 'InputTextarea', header: t('common.sellerAddress'), className: 'md:col-4', labelClassName: 'md:col-4', inputClassName: 'md:col-8', required: true },
      { field: 'buyerAddress', type: 'InputTextarea', header: t('common.buyerAddress'), className: 'md:col-4', labelClassName: 'md:col-4', inputClassName: 'md:col-8', required: true },
    ],
    layout: 'Horizontal'
  });

  const handleClose = () => {
    setDisplay(false)
    setValue({
      sellerTaxCode: null,
      buyerTaxCode: null,
      sellerLegalName: null,
      buyerLegalName: null,
      sellerAddress: null,
      buyerAddress: null,
    })
    setInvoices([])
  }

  useEffect(() => {
    if (display) {
      InvoiceDiscountList.get(selectedItems.id).then((data) => {
        setDiscountInvoiceAttachment(data)
        setRegisterInvoice({ ...data.invoiceDiscountListItems[0], buyerTaxCode: data.buyerTaxCode })
        setValue({
          ...data
        })
      })
    }
  }, [display, selectedItems])

  return (
    <>
      <Dialog
        header={t('common.discountInvoiceAttachmentTitle')}
        visible={display} position="top"
        style={{ width: '100vw' }}
        onHide={handleClose}
        footer={() => <>
          <Button
            // icon="pi pi-plus"
            label={t('common.close')}
            className="p-button-outlined mr-4"
            onClick={handleClose}
          />
          <Button
            icon="pi pi-plus"
            label={t('common.saveAndExportDiscountInvoice')}
            className="p-button-outlined mr-4"
            onClick={() => {
              if (!valid()) {
                return ToastService.error(t('common.fillRequiredInfo'));
              }
              InvoiceDiscountList.update(
                selectedItems.id, {
                ...getValue(),
                invoiceDiscountListItems: discountInvoiceAttachment.invoiceDiscountListItems.map(invoice => ({
                  ...invoice,
                  invoiceCode: invoice.invoiceSerial,
                  buyerTaxCode: getValue().buyerTaxCode,
                }))
              }).then(() => {
                setDisplay(false)
                reloadLazyData()
              })
            }}
          />
        </>}
      >
        {renderForm()}
        <p className="font-bold text-xl mt-4">{t('common.discountedInvoiceListTitle')}</p>
        <div className="flex align-items-center gap-4" >
          <Button
            icon="pi pi-plus"
            label={t('common.addInvoice')}
            className="p-button-outlined"
            onClick={() => setDisplaySelectInvoiceDiscounted(true)}
          />
          <Button
            icon="pi pi-trash"
            label={t('common.deleteInvoiceRow')}
            className="p-button-outlined p-button-danger"
            onClick={() => {
              const selectedIds = selected.map(product => product.id);
              const updatedInvoices = discountInvoiceAttachment.invoiceDiscountListItems.filter(invoice => !selectedIds.includes(invoice.id));
              setDiscountInvoiceAttachment({ ...discountInvoiceAttachment, invoiceDiscountListItems: updatedInvoices });
              setSelected(null);
            }}
          />
          <i>({t('common.discountedInvoiceHint')})</i>
        </div>

        {/* <span>(Vui lòng ấn "Thêm hóa đơn" để lấy Danh sách hóa đơn lên Bảng kê hóa đơn chiết khấu)</span> */}
        <DataTable
          value={discountInvoiceAttachment.invoiceDiscountListItems}
          tableStyle={{ width: '100%' }}
          showGridlines
          selectionMode={null}
          selection={selected}
          onSelectionChange={(e) => setSelected(e.value)}
          dataKey="id"
          footerColumnGroup={
            <ColumnGroup>
              <Row>
                <Column colSpan={7} footer={t('common.total')} />
                <Column
                  colSpan={1}
                  align='right'
                  footer={new Intl.NumberFormat('vi-VN').format(discountInvoiceAttachment.invoiceDiscountListItems.reduce((sum, num) => sum + num.totalAmountWithoutVAT, 0))}
                />
                <Column
                  colSpan={1}
                  align='right'
                  footer={new Intl.NumberFormat('vi-VN').format(discountInvoiceAttachment.invoiceDiscountListItems.reduce((sum, num) => sum + num.vatAmount, 0))} />
                <Column
                  colSpan={1}
                  align='right'
                  footer={new Intl.NumberFormat('vi-VN').format(discountInvoiceAttachment.invoiceDiscountListItems.reduce((sum, num) => sum + num.totalAmount, 0))} />
                <Column colSpan={1} />
              </Row>
            </ColumnGroup>
          }
          className='mt-4'
        >
          <Column selectionMode="multiple" style={{ width: '50px' }} align='center'></Column>
          <Column field="" header={t('common.sequenceNumber')} body={((data, options) => options.rowIndex + 1)} style={{ width: '50px' }} align='center'></Column>
          <Column field="invoiceSerial" header={t('common.symbol')} style={{ width: '100px' }} align='center'></Column>
          <Column field="invoiceNumber" header={t('common.invoiceNo')} style={{ width: '100px' }} align='center'></Column>
          <Column field="invoiceDate" header={t('common.invoiceDate')} style={{ width: '150px' }} align='center' body={(data, options) => moment(data).format('DD/MM/YYYY')}></Column>
          <Column field="currencyCode" header={t('common.currencyUnit')} style={{ width: '120px' }} align='center'></Column>
          <Column field="exchangeRate" header={t('common.exchangeRate')} style={{ width: '80px' }} align='center'></Column>
          <Column
            field="totalAmountWithoutVAT"
            header={t('common.totalBeforeTax')}
            align='right'
            alignHeader='center'
            body={(data, options) =>
              new Intl.NumberFormat('vi-VN').format(data.totalAmountWithoutVAT)
            }
          />
          <Column
            field="vatAmount"
            header={t('common.totalTax')}
            align='right'
            alignHeader='center'
            body={(data, options) => new Intl.NumberFormat('vi-VN').format(data.vatAmount)}
          />
          <Column
            field="totalAmount"
            header={t('common.totalPayment')}
            align='right'
            alignHeader='center'
            body={(data, options) => new Intl.NumberFormat('vi-VN').format(data.totalAmount)}
          />
          <Column
            field="taxAuthorityCode"
            header={t('common.taxAuthorityCode')} align='center'></Column>
        </DataTable>
      </Dialog>
      <DialogSelectInvoiceDiscounted
        display={displaySelectInvoiceDiscounted}
        setDisplay={setDisplaySelectInvoiceDiscounted}
        registerInvoice={registerInvoice}
        addSelectedItems={(data) => {
          const items = [
            ...discountInvoiceAttachment.invoiceDiscountListItems,
            ...data.filter(
              (newItem) =>
                !discountInvoiceAttachment.invoiceDiscountListItems.some(
                  (existingItem) => existingItem.id === newItem.id
                )
            ),
          ]
          setDiscountInvoiceAttachment({ ...discountInvoiceAttachment, invoiceDiscountListItems: items })
          setDisplaySelectInvoiceDiscounted(false);

        }}
      />
    </>
  )
}

export default DialogDiscountInvoiceAttachment
